export const MAXIMUM_RECIPE_SERVINGS = 12;
